import { render } from "./ResetUserData.vue?vue&type=template&id=1f83d38a&scoped=true"
import script from "./ResetUserData.vue?vue&type=script&lang=js"
export * from "./ResetUserData.vue?vue&type=script&lang=js"

import "./ResetUserData.vue?vue&type=style&index=0&id=1f83d38a&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f83d38a"]])

export default __exports__